<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des équipes</h2>
    <p class="page-subtitle">Créez des équipes et affectez des utilisateurs</p>
  </div>
  <button (click)="openCreateDialog()" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouvelle équipe
  </button>
</div>

@if (errorMessage) {
<div class="alert alert-error mb-4">
  {{ errorMessage }}
  <button class="close-alert" (click)="errorMessage = ''">×</button>
</div>
}
@if (successMessage) {
<div class="alert alert-success mb-4">
  {{ successMessage }}
  <button class="close-alert" (click)="successMessage = ''">×</button>
</div>
}

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Rechercher une équipe..."
          class="search-input"
        >
      </div>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivés
        </label>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="modern-table">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Description</th>
          <th>Membres</th>
          <th>État</th>
          <th class="actions-cell">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (team of teams; track team.id) {
        <tr class="clickable-row" (click)="openMembersDialog(team)">
          <td class="font-bold">{{ team.name }}</td>
          <td>{{ team.description || '-' }}</td>
          <td>{{ team.membersCount || 0 }}</td>
          <td>
            @if (team.archived) {
              <span class="badge-archived">Archivée</span>
            } @else {
              <span>-</span>
            }
          </td>
          <td class="actions-cell">
            <div class="actions-wrapper">
              <button (click)="$event.stopPropagation(); openEditDialog(team)" class="btn-icon" title="Modifier" [disabled]="team.archived">
                <mat-icon aria-hidden="true">edit</mat-icon>
              </button>
            </div>
          </td>
        </tr>
        } @empty {
        <tr class="empty-row">
          <td colspan="5">
            <div class="empty-state">
              <mat-icon class="empty-icon" aria-hidden="true">groups</mat-icon>
              <p>Aucune équipe configurée</p>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
